import React, { useMemo } from "react";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getUserById } from "../../../store/hub/users";
import { getLoggedInUserId } from "../../../store/hub/loggedInUser";
import {
  getTeamSortMetricIds,
  teamHasHubConversionEntry,
} from "../../../store/hub/hubConversionData";
import { getUserMetricNumericForPeriod } from "../../../store/hub/userConversionData";
import { getSelectedTimePeriod } from "../../../store/ui/conversion";
import User from "../../../features/user";

function sortKeyForMetric(value) {
  return value == null ? Number.NEGATIVE_INFINITY : value;
}

export default function Team(props) {
  const userSelector = useSelector(getUserById);
  const userIds = props.selectedTeam.UserIds;
  const teamLeaderIds = props.selectedTeam.TeamLeaderUserIds;
  const loggedInUserIdSelector = useSelector(getLoggedInUserId);
  const loggedInUserId = props.selectedTeam.MemberOf
    ? loggedInUserIdSelector()
    : null;
  const selectedTimePeriod = useSelector((state) =>
    getSelectedTimePeriod(state.ui.conversion)
  );
  const teamId = props.selectedTeam.Id;
  const hubConversionData = useSelector(
    (state) => state.entities.hubConversionData
  );
  const sortMetricIds = useSelector((state) =>
    getTeamSortMetricIds(state.entities.hubConversionData, teamId)
  );
  const userConversionData = useSelector((state) => state.entities.userConversionData);

  const hasHubConversionInStore = teamHasHubConversionEntry(
    hubConversionData,
    teamId
  );
  const hasSortMetricsEntry = sortMetricIds !== undefined;
  const primarySortMetricId = sortMetricIds?.primarySortMetricId ?? null;
  const isSorting =
    hasHubConversionInStore &&
    hasSortMetricsEntry &&
    primarySortMetricId != null &&
    Boolean(selectedTimePeriod);

  const sortedUserIds = useMemo(() => {
    const ids = [...userIds];
    if (!isSorting) return ids;
    if (
      loggedInUserId != null &&
      !ids.some((id) => id == loggedInUserId)
    ) {
      ids.push(loggedInUserId);
    }
    const primaryId = primarySortMetricId;
    const secondaryId = sortMetricIds?.secondarySortMetricId ?? null;
    ids.sort((a, b) => {
      const va = getUserMetricNumericForPeriod(
        userConversionData,
        a,
        primaryId,
        selectedTimePeriod
      );
      const vb = getUserMetricNumericForPeriod(
        userConversionData,
        b,
        primaryId,
        selectedTimePeriod
      );
      const cmpPrimary = sortKeyForMetric(vb) - sortKeyForMetric(va);
      if (cmpPrimary !== 0) return cmpPrimary;
      if (secondaryId == null) return 0;
      const sa = getUserMetricNumericForPeriod(
        userConversionData,
        a,
        secondaryId,
        selectedTimePeriod
      );
      const sb = getUserMetricNumericForPeriod(
        userConversionData,
        b,
        secondaryId,
        selectedTimePeriod
      );
      return sortKeyForMetric(sb) - sortKeyForMetric(sa);
    });
    return ids;
  }, [
    userIds,
    sortMetricIds,
    selectedTimePeriod,
    userConversionData,
    isSorting,
    primarySortMetricId,
    hubConversionData,
    loggedInUserId,
  ]);

  let loggedInUser = null;
  let loggedInUserTeamLeader = false;
  let loggedInUserBanner = null;
  if (props.selectedTeam.MemberOf && loggedInUserId != null) {
    loggedInUser = userSelector(loggedInUserId);
    loggedInUserTeamLeader = teamLeaderIds.some(
      (userId) => userId === loggedInUserId
    );
    if (loggedInUserTeamLeader === true) {
      loggedInUserBanner = "Team Manager";
    } else if (loggedInUser && loggedInUser.Banner) {
      loggedInUserBanner = loggedInUser.Banner;
    }

  }

  return (
    <Grid item xs={12}>
      <Grid container justifyContent={"center"} spacing={2}>
        {!isSorting && loggedInUser ? (
          <User
            user={loggedInUser}
            size={props.size}
            banner={loggedInUserBanner}
          />
        ) : null}
        {sortedUserIds.map((id) => {
          let user = userSelector(id);
          let isTeamLeader = teamLeaderIds.some((userId) => userId === id);
          let banner = null;
          if (isTeamLeader === true) {
            banner = "Team Manager";
          } else if (user && user.Banner) {
            banner = user.Banner;
          }
          if (user)
            return (
              <User
                user={user}
                banner={banner}
                key={"user-" + user.Id}
                size={props.size}
              />
            );
          return null;
        })}
      </Grid>
    </Grid>
  );
}
